var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const GET_SET_CASHIER_BOX = (storeId) => `api/store/${storeId}/cashierbox`;
const GET_SET_CASHIER_BOX_MOVEMENT = (storeId, cashierBoxId) => `/api/store/cashierbox/movement/${storeId}/${cashierBoxId}`;
export const deleteCashierBoxById = function (storeId, id) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.delete(`${GET_SET_CASHIER_BOX(storeId)}/${id}`, config);
        }
        catch (error) {
            console.error('Error fetching getStoreStaff:', error);
            throw error;
        }
    });
};
export const deleteCashierBoxMovementById = function (_a) {
    return __awaiter(this, arguments, void 0, function* ({ storeId, cashierBoxId, movementId }) {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.delete(`${GET_SET_CASHIER_BOX_MOVEMENT(storeId, cashierBoxId)}/${movementId}`, config);
        }
        catch (error) {
            console.error('Error fetching getStoreStaff:', error);
            throw error;
        }
    });
};
